/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Targetorchestratorv2FolderStats } from '../models/Targetorchestratorv2FolderStats';
import { HttpFile } from '../http/http';

/**
* Response listing all the target folders
*/
export class V2ListTargetFoldersResponse {
    /**
    * List of folders and their stats that targets reside in
    */
    'folders'?: Array<Targetorchestratorv2FolderStats>;
    /**
    * Token for the next page.  indicates no next results
    */
    'nextPageToken'?: string;
    /**
    * The number of total targets associated to the request ID
    */
    'totalSize'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "folders",
            "baseName": "folders",
            "type": "Array<Targetorchestratorv2FolderStats>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "next_page_token",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalSize",
            "baseName": "total_size",
            "type": "number",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return V2ListTargetFoldersResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

